export default "__VITE_ASSET__CSbfaztL__"